export var surface_core__ask__entitites__askentities__Application;
(function (surface_core__ask__entitites__askentities__Application) {
    let type;
    (function (type) {
        type["APPLICATION"] = "Application";
    })(type = surface_core__ask__entitites__askentities__Application.type || (surface_core__ask__entitites__askentities__Application.type = {}));
})(surface_core__ask__entitites__askentities__Application || (surface_core__ask__entitites__askentities__Application = {}));
